// extracted by mini-css-extract-plugin
module.exports = {"chartPlaceHolder":"Parking_chartPlaceHolder__1kg_4","chartLegend":"Parking_chartLegend__kMcab"};